import { render, staticRenderFns } from "./DiagnosticCodeAutocomplete.vue?vue&type=template&id=4b5983dc&scoped=true&"
import script from "./DiagnosticCodeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DiagnosticCodeAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticCodeAutocomplete.vue?vue&type=style&index=0&id=4b5983dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5983dc",
  null
  
)

export default component.exports